import { useState } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";

import { useDispatch } from "react-redux";
import api from "@/services/api.service";
import { SAVE_HELP_CENTER_SUCCESS } from "@/redux/types/help_center.types";

//CKEditor5
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import classes from "./helpCenter.module.scss";
const QuestionForm = ({ post_id, handleCloseAddModal, show }) => {
	let initialState = {
		title: "",
		description: "",
	};

	const dispatch = useDispatch();
	const { addToast } = useToasts();
	const [question, setQuestion] = useState(initialState);

	const handleInputChange = (e) => {
		e.preventDefault();
		const { name, value } = e.target;
		setQuestion({ ...question, [name]: value });
	};
	const handleCKEditor = (event, editor) => {
		const data = editor.getData();
		setQuestion({ ...question, description: data });
	};

	const handleOnSubmit = () => {
		const params = {
			post_id,
			title: question.title,
			description: question.description,
		};
		api.post("/admin/add_answer", params).then((response) => {
			addToast(response.message, {
				appearance: "success",
			});
			dispatch({
				type: SAVE_HELP_CENTER_SUCCESS,
				payload: {
					questions: response.data.questions.data,
				},
			});
			handleCloseAddModal();
		});
		setQuestion(initialState);
	};

	function uploadAdapter(loader) {
		return {
			upload: () => {
				return new Promise((resolve, _reject) => {
					const body = new FormData();
					loader.file.then((file) => {
						body.append("files[]", file);
						api.post("/admin/upload_answer_images", body).then((response) => {
							resolve({
								default: response.url,
							});
						});
					});
				});
			},
		};
	}

	function uploadPlugin(editor) {
		editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
			return uploadAdapter(loader);
		};
	}

	return (
		<Modal show={show} onHide={handleCloseAddModal} backdrop="static" keyboard={false} size="lg" enforceFocus={false}>
			<Modal.Header closeButton>
				<Modal.Title>Agregar una pregunta y respuesta</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form>
					<Form.Group>
						<Form.Label>Pregunta</Form.Label>
						<Form.Control type="text" placeholder="Ingresa la pregunta" name="title" value={question.title} onChange={handleInputChange} />
					</Form.Group>
					<Form.Group>
						<CKEditor
							editor={ClassicEditor}
							onChange={handleCKEditor}
							config={{
								extraPlugins: [uploadPlugin],
								mediaEmbed: {
									previewsInData: true,
								},
							}}
						/>
					</Form.Group>
					<div className={`${classes.form_button}`}>
						<Button onClick={handleOnSubmit} className={`${classes.button}`}>
							Guardar
						</Button>
					</div>
				</Form>
			</Modal.Body>
		</Modal>
	);
};

export default QuestionForm;
